<template>
    <pdf ref="pdf" src="/MESspecification.pdf"></pdf>
</template>
<script>
// 导入文件
import pdf from 'vue-pdf'
export default {
  // 注册文件
  components: {pdf}
}
</script>